<template>
  <div class="config-ini-container">
    <div class="d-flex">
      <div />
      <v-spacer />
      <v-btn
        @click="showJson"
        class="info mr-2"
      >
        查看
      </v-btn>
      <v-btn
        @click="openAddTopLevelDialog"
        class="info mr-2"
      >
        新增
      </v-btn>
      <v-btn
        @click="saveChanges"
        class="primary"
        :loading="isSaving"
        :disabled="isSaving"
      >
        保存
      </v-btn>
    </div>

    <div class="card-grid mt-4">
      <div
        v-for="(item, index) in configIniArray"
        :key="index"
        class="card"
      >
        <div class="card-header">
          <div class="d-flex align-center">
            <h3>{{ item.type }}</h3>
            <v-spacer />
            <v-btn
              icon
              small
              class="ml-2"
              @click="openAddDialog(item)"
            >
              <v-icon small>
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              icon
              small
              class="ml-2"
              @click="deleteItem(index)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="card-body">
          <!-- If value is an array of objects -->
          <div v-if="Array.isArray(item.value)">
            <div
              v-for="(subItem, subIndex) in item.value"
              :key="subIndex"
              class="sub-item"
            >
              <div class="flex-row">
                <strong>{{ subItem.type }}:</strong>
                <v-text-field
                  v-model="subItem.value"
                  class="edit-input"
                  dense
                  outlined
                  hide-details
                />
                <v-btn
                  icon
                  small
                  class="ml-2"
                  @click="deleteSubItem(item, subIndex)"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog for adding new key-value pair -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>添加新配置</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newItem.key"
                  label="Key"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newItem.value"
                  label="Value"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addNewItem"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="sectionDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>添加新配置</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newSectionName"
                  label="Key"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            取消
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addNewSection"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDetailJson"
      max-width="600"
    >
      <v-card
        class="pa-2 ml-0 ma-1 text-body-1 mt-4"
        color="#eee"
        elevation="0"
      >
        <div class="mt-2 text-body-1 font-weight-regular">
          <json-viewer
            :value="currentJson"
            copyable
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getConfigIni, updateConfigIni } from '@/model/dataLayer/api/configIni'
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'ConfigIni',
  components: {
    JsonViewer
  },
  data () {
    return {
      showDetailJson: false,
      configIni: {},
      configIniArray: [],
      editedValues: {},
      isSaving: false,
      saveSuccess: false,
      saveError: null,
      dialog: false,
      currentItem: null,
      sectionDialog: false,
      newItem: {
        key: '',
        value: ''
      },
      newSectionName: '',
      currentJson: {
        Dishes: {
          DinnerDishId: '',
          ScanQrOpenTableConsumeTypeId: 5,
          OrderByDCT: true,
          ExtraFreeInfoBonGroupId: ''
        },
        Bon: {
          QR: '',
          ShortKitchen: false,
          UseCatLine: false,
          PrintingChinese: true,
          PrintingVietnamese: false,
          PrintWhenTotalZero: true,
          StickerLineLength: 26,
          DishSalesBonAttrOrderBy: 'count',
          DishSalesBonDishOrderBy: 'totalPrice',
          UseAutoRetry: true,
          PrintCallServantBon: false,
          ForceMergeDishesOnSameKitchenBON: false,
          ZBonAddPaidTotalWithoutTip: false,
          PrintStornoBon: true,
          StornoBonUseRealLang: false,
          DrinkGroupId: 2,
          UseEuropeMode: 0,
          ZBonPaidCountOnOrder: false,
          ZBonCombinedManualPrintAllowSameDay: false,
          PrintInTestMode: false,
          ZBonPdfReduceLineFeed: false,
          PrintChangeTableBon: false,
          ChangeTableBonGroupIdExclude: '',
          dishStatisticUseRealAverage: false,
          dishStatisticPrecision: 2,
          dishStatisticOnlyShowCompleted: false,
          SplitOrderNoKDS: false,
          ShangMiFetchSticker: false
        },
        Email: {
          AutoSend3in1Today: true,
          AutoSend3in1LastMonth: false,
          AutoSendSummaryLastMonth: false,
          DoNotSendZbonWhenPrint: false,
          SendSingleBonWithoutZip: false
        },
        Takeaway: {
          AcceptOnlyTodayOrder: true,
          ScanQrNoConfirm: true,
          ScanQrNoKitchenBonBeforeConfirm: false
        },
        Restaurant: {
          EnableAutoUpdate: false,
          AutoAcceptOrder15MinuteBefore: false,
          NotReallyAddToTable: false,
          OnlyTakeaway: false,
          OnlyOrder: false,
          RestaurantId: '0001',
          ServeMail: 'info@innerken.com',
          GetMyIpStatic: false,
          MyStaticIp: null,
          StopZBonPrint: true,
          TakeawayStartCount: 1,
          CheckPasswordStrict: false,
          AutoAcceptTakeAway: false,
          AutoFinishTakeawayOrder: false,
          RepeatToFrontGroup: false,
          CallServiceWhenTakeaway: true,
          CallServiceWhenTakeawayButDoNotPrintOrder: false,
          PrintKitchenBon: true,
          AcsServer: 'http://cloud-minus.aaden.io/',
          RepeatStornoBonToKitchen: true,
          CheckoutNoServantUpdate: false,
          DatevCsvGroupByDate: false,
          DatevCsvFixDiscount: false,
          KDSSortByDOD: false,
          DashboardOrderCountExclude0: false
        }
      }
    }
  },
  async mounted () {
    await this.refreshData()
  },
  methods: {
    showJson () {
      this.showDetailJson = true
    },
    openAddTopLevelDialog () {
      this.currentItem = null
      this.newItem = {
        key: ''
      }
      this.sectionDialog = true
    },

    openAddDialog (item) {
      this.currentItem = item
      this.newItem = {
        key: '',
        value: ''
      }
      this.dialog = true
    },

    closeDialog () {
      this.dialog = false
      this.sectionDialog = false
      this.currentItem = null
      this.newSectionName = ''
      this.newItem = {
        key: '',
        value: ''
      }
    },
    addNewSection () {
      this.configIniArray.push({
        type: this.newSectionName,
        value: []
      })
      this.sectionDialog = false
    },

    addNewItem () {
      if (!this.newItem.key || !this.newItem.value) {
        return
      }

      if (this.currentItem === null) {
        // Add new top-level item
        this.configIniArray.push({
          type: this.newItem.key,
          value: this.newItem.value
        })
      } else if (this.currentItem && Array.isArray(this.currentItem.value)) {
        // Add to existing array
        this.currentItem.value.push({
          type: this.newItem.key,
          value: this.newItem.value
        })
      } else if (this.currentItem) {
        // Convert simple value to array
        this.currentItem.value = [
          {
            type: this.newItem.key,
            value: this.newItem.value
          }
        ]
      }
      this.closeDialog()
    },

    deleteItem (index) {
      this.configIniArray.splice(index, 1)
    },

    deleteSubItem (item, subIndex) {
      // Confirm before deleting
      if (Array.isArray(item.value)) {
        item.value.splice(subIndex, 1)
      }
    },

    async saveChanges () {
      try {
        this.isSaving = true

        // Transform configIniArray back to the structure of configIni
        const transformedConfig = {}

        for (const item of this.configIniArray) {
          if (Array.isArray(item.value)) {
            // Handle nested objects
            transformedConfig[item.type] = {}
            for (const subItem of item.value) {
              transformedConfig[item.type][subItem.type] = subItem.value
            }
          } else {
            // Handle simple values
            transformedConfig[item.type] = item.value
          }
        }
        console.log(transformedConfig, 'config')

        // Call the API to update the config
        await updateConfigIni(transformedConfig)

        // Update the local configIni object
        console.log('Configuration saved successfully')
      } catch (error) {
        console.error('Error saving configuration:', error)
      } finally {
        this.isSaving = false
      }
    },

    async refreshData () {
      try {
        this.configIni = await getConfigIni()

        // Transform configIni object into array of {type, value} objects
        const array = Object.keys(this.configIni)
        this.configIniArray = array.map(key => {
          const value = this.configIni[key]
          // Transform value using Object.keys if it's an object
          const transformedValue = typeof value === 'object' && value !== null
            ? Object.keys(value).map(valueKey => ({ type: valueKey, value: value[valueKey] }))
            : value
          return { type: key, value: transformedValue }
        })
      } catch (error) {
        console.error('Error refreshing data:', error)
      }
    }
  }
}
</script>

<style scoped>
.config-ini-container {
  padding: 20px;
}

/* Save controls */
.save-controls {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.save-button {
  padding: 8px 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
}

.save-button:hover:not(:disabled) {
  background-color: #45a049;
}

.save-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.save-feedback {
  margin-left: 15px;
}

.save-success {
  color: #4caf50;
  font-weight: bold;
}

.save-error {
  color: #f44336;
  font-weight: bold;
}

/* Input fields */
.edit-input {
  margin-top: 0;
  margin-bottom: 0;
}

.v-text-field.edit-input >>> .v-input__control {
  min-height: 40px;
}

.v-text-field.edit-input >>> .v-input__slot {
  min-height: 40px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two cards per row */
  gap: 20px;
}

.card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #f5f5f5;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.card-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.card-body {
  padding: 16px;
}

.sub-item {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eee;
}

.sub-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.flex-row strong {
  flex: 0 0 30%;
  margin-right: 10px;
}

.flex-row .v-text-field {
  flex: 1;
}

.simple-value {
  font-size: 16px;
  color: #555;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr; /* One card per row on smaller screens */
  }
}
</style>
